<template>
  <div class="select-sales modal-center">
    <scroller-load
      :eof="loading_param.eof"
      :is_height_tall="false"
      :loading="loading_param.loading"
      @loadMore="loadMore"
    >
      <div class="sales-item-box" v-if="!isInit">
        <el-table
          :border="true"
          :data="userinfos"
          :row-style="{border: '3px solid #ebeef5'}"
          :show-header="false"
          current-row-key="1"
          style="width: 100%"
        >
          <el-table-column label width="70">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" size="medium" v-model="radio">{{''}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column label>
            <template slot-scope="scope">
              <div class="sales-item-icon">
                <img-lazy
                  :default_src="no_photo"
                  :src="scope.row.photo_url"
                  class="mui-icon-image"
                />
              </div>
              <div class="sales-item-info">
                <div class="name overflow-ellipsis-line1">
                  <span>{{scope.row.customer_service_name ? scope.row.customer_service_name : scope.row.name}}</span>
                  <em>{{agent.agent_info.agent_name_for_short}}</em>
                </div>
                <div class="tel">
                  <img src="@/assets/images/customer/tel_03.png">
                  <span>{{scope.row.cell ? scope.row.cell : scope.row.tel}}</span>
                </div>
                <div class="tel address overflow-ellipsis-line1">
                  <img src="@/assets/images/customer/place_03.png">
                  <span>{{scope.row.address ? scope.row.address : agent.agent_info.address}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </scroller-load>
    <div class="select-sales-but">
      <input @click="confirm()" style="cursor: pointer;" type="button" value="确定">
    </div>
  </div>
</template>
<script>
import { ScrollerLoad } from '@/components/scroll_load'
import no_photo from '@/assets/images/html/no_photo.gif'
import cookieUtil from '@/api/cookieUtil'
export default {
  name: 'SelectSales',
  componentName: 'SelectSales',
  components: {
    ScrollerLoad
  },
  data () {
    return {
      radio: 0,
      no_photo: no_photo,
      url: 'userinfo/select_sales',
      loading_param: {  //上拉加载相关参数
        loading: false,
        eof: false,
      },
      agent: {},
      userinfos: [],
      param: {
        current: 1,
        size: 10,
      },
      is_sale_right: false,
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      member_id: this.$sessionStorageUtil.get('member_id'),
      user_id: 0,
      bind_agent_url: 'binding_relation/bind_agent',
      selected_user: {},
      is_consult_route_info: false,
      route_url_param: {},
      consult_url: this.$getOldWebUrl() + 'chat/chat.jsp',
      consult_route_url: '',
      from: this.activity,
      form_info: {
        contact_tel: '',
        source: 'oct',
        location_code: '1-1-',
        sell_mode: 0,
        favorable_amount_input: 0.00,
        price_num_a: 1,
        totalNum: 1,
        route_plan_source: 'oct',
      },
      is_login: false,
    }
  },
  props: {
    activity: {
      type: String,
      default: 'consult'
    }
  },
  created () {
    this.is_login = this.$isLogin(1)  //判断是否登陆
    this.loading_param.loading = true  //设置状态：开始加载
    let params = {
      page: this.param,
    }
    this.$myGet(this.url, params)
      .then(res => {
        if (res.response.data.agent_info) {
          this.agent = res.response.data.agent_info
          this.selected_user = this.agent.userinfo
          if (this.selected_user && 'order' == this.from) {
            this.form_info._user_name = this.selected_user.username
            this.form_info._category_code = this.selected_user.location
            this.form_info._source = this.selected_user.source
          }
        }
        var userinfoList = res.response.data.userinfos
        if (userinfoList.length > 0) {
          userinfoList.forEach(item => {
            this.userinfos.push(item)
          })
        }
        this.loading_param.eof = userinfoList.length < this.param.size
        if (this.userinfos && this.agent) {
          this.isInit = false
        }
        this.loading_param.loading = false  //设置状态：加载完成

        this.isConsultRouteInfo() //判断是否是咨询产品，初始化consult_url
      }).catch(err => {
        this.loading_param.loading = false  //设置状态：加载完成
        this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
      })
  },
  methods: {
    confirm () {
      if (this.activity == 'order') {
        this.addOrder()
      } else {
        this.consult()
      }
    },
    consult () {
      var loading = this.$loadingIndicator.eleOpen('绑定销售中...')
      let p = this.bindAgent(this.radio)
      p.then((username) => {
        loading.close()
        if (this.$route.query.old_consult == 1) {
          let parentEl = window.opener
          parentEl.postMessage(username, this.$getOldWebUrl())
          window.close()
          return
        }
        this.$domUtils.dispatch(this, 'CommonFrame', 'select.sale', [username])
      })
    },
    isConsultRouteInfo () {
      const route_plan_id = this.$route.query.route_plan_id
      if (route_plan_id) {
        const route_source = this.$route.query.route_source
        const route_id = this.$route.query.route_id
        const route_info_url = window.location.protocol + '//' + window.location.host + '/v/common2/visaRouteInfo?route_id=' + route_id
        this.consult_route_url = '&route_source=' + route_source + '&route_id=' + route_id + '&selected_id=' + route_plan_id
          + '&route_info_url=' + route_info_url
      }
    },
    bindAgent (index) {
      let promise = new Promise((resolve, reject) => {
        this.selected_user = this.userinfos[index]
        if (this.is_login) { //登陆了才绑定销售，未登陆不绑定
          if (this.$route.query.old_consult != 1 && this.selected_user.username == this.$sessionStorageUtil.get('bind_agent')) {
            this.form_info._user_name = this.selected_user.username
            resolve(this.selected_user.username)
          } else {
            const form_info = {
              user_id: this.selected_user.user_id,
              member_id: this.member_id,
            }
            this.$myPost(this.bind_agent_url, form_info)
              .then(res => {
                const rcode = res.response.data.rcode
                if (rcode == 0) {
                  //TODO [xsw] 是否应该把会员绑定的销售设置到sessionStorage中
                  this.$sessionStorageUtil.set('domain_name', res.response.data.domain_name) //重新设置域名
                  cookieUtil.set('new_domain_name', res.response.data.domain_name)
                  this.$sessionStorageUtil.set('bind_agent', this.selected_user.username) //重新设置绑定销售的username
                  this.$myGet('webconfig/type')  //重新设置网站类型
                    .then(res => {
                      const type = res.response.data.type
                      this.$sessionStorageUtil.set('web_type', type ? type : 1)
                      cookieUtil.set('new_web_type', type ? type : 1)
                    })
                    .catch(err => {
                      this.$msg('[' + err.status + ']' + err.message, 'error')
                    })
                  this.$msg('绑定销售客服' +
                    (this.selected_user.customer_service_name ? this.selected_user.customer_service_name : this.selected_user.name) +
                    '成功', 'success')
                  if (this.selected_user && 'order' == this.from) {
                    this.form_info._user_name = this.selected_user.username
                    this.form_info._category_code = this.selected_user.location
                    this.form_info._source = this.selected_user.source
                  }
                } else {
                  this.$msg('失败：[' + res.status + ']' + res.response.data.messages[0], 'error')
                }
                resolve(this.selected_user.username)
              })
              .catch(err => {
                this.$msg('[' + err.status + ']' + err.message, 'error')
                resolve(this.selected_user.username)
              })
          }
        } else {
          resolve(this.selected_user.username)
        }
      })
      return promise
    },
    getUserinfoList () {
      this.loading_param.loading = true
      this.param.current++
      this.$myGet(this.url, this.param)
        .then(res => {
          var userinfoList = res.response.data.userinfos
          if (userinfoList.length > 0) {
            userinfoList.forEach(item => {
              this.userinfos.push(item)
            })
          }
          this.loading_param.eof = userinfoList.length < this.param.size
          this.isInit = false
          this.loading_param.loading = false  //设置状态：加载完成
        }).catch(err => {
          this.loading_param.loading = false  //设置状态：加载完成
          this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
        })
    },
    loadMore () {
      this.getUserinfoList()
    },
    addOrder () {
      var loading = this.$loadingIndicator.eleOpen('订单正在提交...')
      let p = this.bindAgent(this.radio)
      p.then((username) => {
        const route_order_add_info = this.$sessionStorageUtil.get('route_order_add_info')
        if (route_order_add_info) {
          for (let key in route_order_add_info) {
            this.form_info[key] = route_order_add_info[key]
          }
        }
        const route_order_contract_info = this.$sessionStorageUtil.get('route_order_contract_info')
        if (route_order_contract_info) {
          for (let key in route_order_contract_info) {
            this.form_info[key] = route_order_contract_info[key]
          }
        }
        const plan_info = this.$sessionStorageUtil.get('route_order_plan_info')
        if (plan_info) {
          this.form_info.product_category = plan_info.product_category
        }
        // 重新设置username ， 因为有可能是在提交订单之前才登陆的会员
        if (this.form_info.username == null) {
          this.form_info.username = this.$sessionStorageUtil.get('username')
        }
        const url = 'order_info/add_order'
        //TODO 测试
        // this.form_info._user_name= ''
        var fields = this.$myPost(url, this.form_info)
        fields.then(res => {
          const rcode = res.response.data.rcode
          var msg = ""
          var is_success = false
          if (rcode == 0) {
            is_success = true
            /*下单成功后清除sessionStorage数据 */
            this.$sessionStorageUtil.remove('route_order_add_info')
            this.$sessionStorageUtil.remove('route_order_contract_info')
            this.$sessionStorageUtil.remove('route_order_plan_info')
            this.$sessionStorageUtil.remove('name_list')
            this.$sessionStorageUtil.remove('dlsr_order_rpid')
          } else {
            msg = res.response.data.messages[0].msg
            is_success = false
          }
          this.$domUtils.dispatch(this, 'CommonFrame', 'close.select.sale')
          loading.close()
          //TODO 测试
          // if(is_success){
          //   this.$msg('成功', 'success', 3000);
          // } else{
          //   this.$msg('失败', 'error', 3000);
          // }
          this.$pushByName('routeOrderResult',
            {
              msg: msg,
              is_success: is_success,
              _user_name: this.selected_user.username,
              order_info_id: res.response.data.order_info_id
            })
        })
          .catch(err => {
            this.$msg('失败catch', 'error', 3000);
            loading.close()
            console.log('err:' + err)
          })
      })
    }
  }
}
</script>
<style scoped>
.custom-el-table {
  border: 5px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/selectSales.vue